import React, { useState } from "react";
import { X, RefreshCcw } from "lucide-react";

export default function PassportUploadModal({ open, onClose, onUpload }) {
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");

  if (!open) return null;

  const handleFile = (f) => {
    if (!f) return;

    if (f.size > 10 * 1024 * 1024) {
      setError(`${f.name} : File Exceeds 10 MB limit`);
      setFile(null);
      return;
    }

    setError("");
    setFile(f);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="w-[600px] bg-white rounded-xl overflow-hidden shadow-lg">
        {/* Purple Header */}
        <div className="bg-[#572575] px-6 py-4">
          <h2 className="text-white text-xl font-semibold">
            Upload Passport file
          </h2>
        </div>

        {/* Main Body */}
        <div className="p-6 relative">
          {/* Close Button */}
          <button
            className="absolute right-5 top-5 text-gray-500"
            onClick={onClose}
          >
            <X size={22} />
          </button>

          {/* Upload Box */}
          <div
            onClick={() => document.getElementById("passportFile").click()}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => {
              e.preventDefault();
              handleFile(e.dataTransfer.files[0]);
            }}
            className="border-2 border-dashed border-[#c9a7e8] rounded-xl py-10 px-4 text-center cursor-pointer"
          >
            <img
              src="/uploadPassport.png"
              className="w-12 mx-auto mb-3 opacity-80"
            />

            <p className="text-[#572575] font-bold">Drag & Drop File Here</p>

            <p className="text-gray-500 text-sm mt-1">
              Supported formats: JPG, PNG, PDF (Max: 10MB)
            </p>

            <p className="font-semibold mt-3 text-black">
              Upload Passport File
            </p>

            <input
              id="passportFile"
              hidden
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              onChange={(e) => handleFile(e.target.files[0])}
            />
          </div>

          {/* SUCCESS OR ERROR */}
          {(file || error) && (
            <div className="mt-6">
              {error ? (
                <>
                  <p className="font-medium text-gray-700 mb-1 flex items-center gap-1">
                    Selected File <span className="text-red-500">ⓘ</span>
                  </p>

                  {/* Error Box */}
                  <div className="border border-red-300 bg-red-50 px-4 py-3 rounded-xl text-red-600 flex justify-between items-center">
                    {error}
                    <X className="cursor-pointer" />
                  </div>
                </>
              ) : (
                <>
                  <p className="font-medium text-green-600 flex items-center gap-1">
                    Upload Successfully{" "}
                    <span className="text-green-600">✔</span>
                  </p>

                  {/* Success File Row */}
                  <div className="border border-green-300 bg-green-50 px-4 py-3 rounded-xl mt-2 flex items-center justify-between">
                    <div className="flex gap-3 items-center">
                      <img src="/pdfIcon.png" className="w-6" />
                      <div>
                        <p className="font-semibold">{file?.name}</p>
                        <p className="text-sm text-gray-600">
                          PDF Document • {(file.size / 1024).toFixed(2)} KB
                        </p>
                      </div>
                    </div>

                    <div className="flex gap-3">
                      <RefreshCcw className="cursor-pointer text-gray-700" />
                      <X
                        className="cursor-pointer text-red-500"
                        onClick={() => setFile(null)}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          )}

          {/* Footer Buttons */}
          <div className="flex justify-end gap-4 mt-8">
            <button
              onClick={onClose}
              className="px-6 py-2 rounded-lg bg-gray-200 font-medium hover:bg-gray-300"
            >
              Cancel
            </button>

            <button
              disabled={!file}
              onClick={() => onUpload(file)}
              className={`px-6 py-2 rounded-lg text-white font-medium shadow ${
                file
                  ? "bg-[#572575] hover:bg-purple-900"
                  : "bg-[#9a7bbd] cursor-not-allowed"
              }`}
            >
              Upload
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
